import { TranslateService } from './../../shared/translate/translate.service';
import { AuthService } from './../../shared/models/auth.service';
import { IKeyValueInterface, WeGoAuthorizedLink, Permission, PermissionType } from './../../shared/config';
import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { VehicleModel, VehicleBlockModel, VTSVehicleModel } from '../models/vehicle.model';
import { VehicleService } from '../models/vehicle.service';
import { Observable } from 'rxjs/Observable';
import { Router, ActivatedRoute } from '@angular/router';
import { WeGoConfig, IAPIResponse, ApplicationRouteURL, UserRoles, DataListModel } from '../../shared/config';

@Component({
  selector: 'wego-vehicle',
  template: require('../views/vtsvehicle-list.component.html'),
  providers: [VehicleService],

})
export class VtsVehicleListComponent implements OnInit {
  urlVTSVehicleAdd: string;
  DataListModel: DataListModel;
  vehicleList: VTSVehicleModel[];
  errorModel: IKeyValueInterface[];
  errorMessage: string;
  isLoading: boolean;
  deleteVehicleMasterHashId: string;
  blockVehicleMasterHashId: string;
  blockFlag: boolean;
  message: string;
  blockState: string;
  isParentCheck: boolean;
  isMultipleDelete: boolean;
  deleteMessage: string;
  model: VehicleBlockModel;
  ownerCompanyHashID: string = "";
  sharedVehicleGroupHashId: string = "";
  lblAvailable: string;
  lblUnavailable: string;
  addVTSVehicleLink: WeGoAuthorizedLink;
  private popupMsg: string;
  private module: string;
  private breadCrumbList: string;

  @ViewChild('successPopup') public successPopup: any;

  urlDefaultPage: string;
  urlVehicleUpdate: string;
  //urlVehicleSVGList: string;


  constructor(private vehicleService: VehicleService
    , private activeRoute: ActivatedRoute
    , private router: Router
    , private authService: AuthService, private translate: TranslateService) {
  }

  ngOnInit() {
    this.module = this.translate.instant('LblVtsVehicle');
    this.breadCrumbList = this.translate.instant('LblListPage', [this.module]);
    this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
    this.model = new VehicleBlockModel();
    //this.DataListModel.searchField = ["fleetId", "contractId", "vin", "licenceTag", "brand", "type", "color"];
    this.DataListModel.searchField = ["obuType","vin","deviceId", "licenceTag"];
    this.urlDefaultPage = this.authService.GetURL(ApplicationRouteURL.URL_DEFAULT_PAGE);
    this.urlVehicleUpdate = this.authService.GetURL(ApplicationRouteURL.URL_VTSVEHICLE_UPDATE);
    this.urlVTSVehicleAdd = this.authService.GetURL(ApplicationRouteURL.URL_VTSVEHICLE_ADD);
    this.GetVehicleList();
    this.addVTSVehicleLink = new WeGoAuthorizedLink(this.urlVTSVehicleAdd, 
      Permission.PR_VTS_VEHICLE_LIST, PermissionType.INSERT,'btn btn-highlight navbar-right', 'LblAddNew');
  }

  public OnSort(sortName: string) {
    this.DataListModel.sortType = sortName;
    this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
    this.GetVehicleList();
  }

  public OnSearch(event: any) {
    this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
    this.GetVehicleList();
  }

  public OnPageChanged(event: any): void {
    this.DataListModel.currentPage = event.page;
    this.GetVehicleList();
  };

  public OnPagingChange(event: any) {
    console.log(this.DataListModel);
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.itemsPerPage = event.itemPerPage;
    this.GetVehicleList();
  }
  public OnExport(event: any) {
    this.isLoading = true;
    this.vehicleService.ExportVTSVehicleList(this.DataListModel)
      .subscribe(
      (res: any) => {
        if (res && res._body) {
          let fileName = "VTS_Vehicle" + new Date().toISOString() + ".csv";
          this.authService.DownloadFile(fileName, res._body);
        }
        this.isLoading = false;
      },
      (error: any) => {
        this.errorMessage = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }



  public GetVehicleList() {
    this.isLoading = true;
    this.vehicleService.GetAllVtsVehicleList(this.DataListModel)
      .subscribe(
      res => {
        this.vehicleList = res.data;
        this.vehicleList.forEach( v  => {
          if (v.obuType.toLowerCase() ==='teltonika' ) {
            v.link = WeGoConfig.TELTONIKA_CONFIG_BASE_URL + "?access_token=" + this.authService.accessToken();
          } else if(v.obuType.toLowerCase() === 'invers') {
            v.link = WeGoConfig.INVERS_CONFIG_BASE_URL + v.deviceId;
          }
        })
        this.DataListModel.totalItems = res.totalRecords;
        this.DataListModel.infoMessage = res.error;
        this.isLoading = false;
      },
      error => {
        this.errorMessage = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }
  ngOnDestroy() {
    this.authService.SetFilter(this.constructor.name, this.DataListModel);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/vehicle/components/vtsvehicle-list.component.ts